var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bac-customers",attrs:{"uk-grid":""}},_vm._l((_vm.$store.state.PageURLTeam.team.members),function(user,i){return _c('div',{key:i,staticClass:"bac-customer-wrapper"},[_c('bac-customer-widget',{attrs:{"user":user}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }